/* global playTimeApiUrl */
import videojs from 'video.js'
import 'videojs-vtt-thumbnails' // サムネイルプラグイン
import 'videojs-contrib-quality-levels' // 画質選択プラグイン
import 'videojs-hls-quality-selector' // 画質選択プラグイン

import scrollLock from './functions/_scrollLock.js' // スクロールロック
import getCookie from './functions/_cookie-getCookie.js' // Cookie取得
import setCookie from './functions/_cookie-setCookie.js' // Cookie発行
const deviceOS = isDeviceOS()
const videoItem = document.getElementById('video')
const skipTimes = [-10, -3, 10, 30]

const speedUi = `
<div class="movieSpeed flex vcenter" style="">
  <select class="rateBox" onchange="changeRate(this.value)">
    <option value="0.25">x0.25</option>
    <option value="0.50">x0.50</option>
    <option value="1.00" selected>x1.00</option>
    <option value="1.25">x1.25</option>
    <option value="1.50">x1.50</option>
    <option value="2.00">x2.00</option>
  </select>
</div>
`

//   ####  ##      #####  #####  #####
//  ##     ##      ##     ##     ##  ##
//   ###   ##      #####  #####  #####
//     ##  ##      ##     ##     ##
//  ####   ######  #####  #####  ##

// スリープ禁止処理　WakeLockSentinel object を格納する
let wakeLock = null
// screen wake lock をリクエストするための関数
function sleepLock(toggle = true) {
  if (toggle) {
    try {
      wakeLock = navigator.wakeLock.request('screen')

      // Screen Wake Lock がリリースされたときの処理
      // wakeLock.addEventListener('release', () => {
      //   console.log('Screen Wake Lock was released')
      // })
      // console.log('Screen Wake Lock is active')
    } catch (err) {
      // console.error(`${err.name}, ${err.message}`)
    }
  } else if (!toggle && wakeLock) {
    try {
      wakeLock.release()
      wakeLock = null
      // console.log('Screen Wake Lock is active')
    } catch (err) {
      // console.error(`${err.name}, ${err.message}`)
    }
  }
}

let player
if (videoItem) {
  // コントロールバーをビデオ範囲外に設置する際の余白を生成する
  const videoFrame = videoItem.parentNode
  const cloneBar = document.createElement('div')
  cloneBar.classList.add('outer-ui')
  cloneBar.classList.add('js-videoSpToggle')
  videoFrame.appendChild(cloneBar) // 最後の子要素として追加

  // デバイス判別用のクラスを当てる
  if (deviceOS === 'pc') {
    document.body.classList.add('device-pc')
  } else {
    document.body.classList.add('device-sp')
  }

  videoSetup()
}
//   ####  #####  ######  ##   ##  #####
//  ##     ##       ##    ##   ##  ##  ##
//   ###   #####    ##    ##   ##  #####
//     ##  ##       ##    ##   ##  ##
//  ####   #####    ##     #####   ##

function videoSetup() {
  // 出力する操作ボタン
  let control = [
    { name: 'playToggle' },
    { name: 'progressControl' },
    { name: 'currentTimeDisplay' },
    { name: 'TimeDivider' },
    { name: 'durationDisplay' },
    { name: 'volumePanel', inline: true },
    { name: 'FullscreenToggle' },
  ]
  if (deviceOS !== 'android') {
    // Android以外はピクチャーインピクチャーボタンを追加
    control.push({ name: 'pictureInPictureToggle' })
  }

  player = videojs('video', {
    controls: true,
    fluid: true,
    autoplay: _get('autoplay') === '1' || videoItem.dataset.autoplay === '1',
    preload: 'none',
    controlBar: {
      children: control,
    },
    html5: {
      hls: {
        overrideNative: !videojs.browser.IS_ANY_SAFARI,
      },
      nativeAudioTracks: false,
      nativeVideoTracks: false,
    },
  })

  /* global videoSrc */
  player.src(videoSrc)

  player.hlsQualitySelector({
    displayCurrentQuality: true,
  })

  player.addChild(CreateSkip(), {})

  // 'loadstart',
  // 'loadedmetadata',
  // 'loadeddata',
  // 'play',
  // 'playing',
  // 'pause',
  // 'suspend',
  // 'seeking',
  // 'seeked',
  // 'waiting',
  // 'canplay',
  // 'canplaythrough',
  // 'ratechange',
  // 'ended',
  // 'emptied',
  // 'error',
  // 'abort',

  // hover時メニュー
  document.getElementById('skip').addEventListener('click', onPause)

  // 再生速度変更ボタンの追加
  player.getChild('controlBar').addChild(CreateRateChange(), {}, 6)

  //  #####  ##   ##  #####  ##     ##  ######
  //  ##     ##   ##  ##     ####   ##    ##
  //  #####  ##   ##  #####  ##  ## ##    ##
  //  ##      ## ##   ##     ##    ###    ##
  //  #####    ###    #####  ##     ##    ##

  player.on(['loadstart'], function (e) {
    // 動画準備段階
    const videoVolume = getCookie('videoVolume') // Cookie取得
    const videoMuted = getCookie('videoMuted') // Cookie取得
    if (videoMuted === 'true') {
      player.muted(true) // ミュートを反映
      setCookie('videoMuted', videoMuted, 60 * 60 * 365, false) // 音量をCookieに格納
    }
    if (!isNaN(videoVolume)) {
      player.volume(parseFloat(videoVolume, 10)) // 音量を反映
      setCookie('videoVolume', videoVolume, 60 * 60 * 365, false) // 音量をCookieに格納
    }

    if (!getNextVideo()) {
      document.getElementById('hovermenu-next').classList.add('hide')
    }

    autoMoveBtnToggle() // 自動再生ボタンの状態を反映

    // console.log(videoItem.dataset.autoplay)
    // if (_get('autoplay') === '1' || videoItem.dataset.autoplay === '1') {
    //   console.log('autoPlay')
    //   player.play() // 自動再生
    // }
  })
  player.on(['loadeddata'], function (e) {
    videoQualityButtonFix()
    document.querySelector('.vjs-quality-selector').classList.add('active')

    // videoDebug(e)
  })
  player.on(['error'], function (e) {
    // videoDebug(e)
  })

  player.on('volumechange', function () {
    // 音量変更時
    setCookie('videoMuted', player.muted(), 60 * 60 * 365, false) // ミュート状態をCookieに格納
    setCookie('videoVolume', player.volume(), 60 * 60 * 365, false) // 音量をCookieに格納
  })

  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (e.target.classList.contains('vjs-mute-control')) {
      // ミュートボタン
      // console.log(player.muted())
      setCookie('videoMuted', player.muted(), 60 * 60 * 365, false) // ミュート状態をCookieに格納
    }
  })

  player.on('ratechange', function () {
    // 再生速度変更時
  })

  player.on(['play', 'pause', 'ended'], function (e) {
    // 再生ボタンのアイコンを差し替える
    if (player.paused()) {
      playButton.innerHTML = '<i class="play-icon movieSkip__icon icon-tri-right"></i>'
    } else {
      playButton.innerHTML = '<i class="play-icon movieSkip__icon icon-pause"></i>'
    }
    if (player.ended()) {
      playButton.innerHTML = '<i class="play-icon movieSkip__icon icon-count-back"></i>'
    }
  })

  //   ####  ##      #####  #####  #####
  //  ##     ##      ##     ##     ##  ##
  //   ###   ##      #####  #####  #####
  //     ##  ##      ##     ##     ##
  //  ####   ######  #####  #####  ##

  player.on(['play'], function (e) {
    sleepLock(true) // スリープ禁止
  })
  player.on(['pause', 'ended'], function (e) {
    sleepLock(false) // スリープ禁止解除
  })

  player.on(['ended'], function (e) {
    if (videoItem.dataset.type === 'free-guest') {
      // 本日の無料動画　非ログイン

      setTimeout(() => {
        document.getElementById('videoSignup').classList.add('active')
        document.getElementById('modalOverlay').classList.add('active')

        scrollLock('body', '#modalOverlay')
      }, 1000)

      return
    }

    // 次の動画がある時の処理
    if (getNextVideo()) {
      if (isFullScreen()) {
        // フルスクリーンを解除
        player.exitFullscreen()
      }
      if (isAutoMove()) {
        // 自動再生が有効ならそのまま移る
        location.href = getNextVideo()
        return
      }

      openNextWindow() // 次の動画画面を出す
    }
  })

  //    ###    #####   ##
  //   ## ##   ##  ##  ##
  //  ##   ##  #####   ##
  //  #######  ##      ##
  //  ##   ##  ##      ##
  // 再生状況送信API
  let playDataTimer
  let trayTimer
  let lastSendTime = 0 // 最後に送信した時間
  let seekTime = 0 // シークした時間
  player.on(['seeked'], function (e) {
    // シークされた
    const time = Math.floor(player.currentTime()) // 小数切り捨てで再生時間取得
    const endTime = Math.floor(player.duration()) // 動画全体の再生時間
    // console.log(time)
    if (lastSendTime + 5 <= time && time !== endTime) {
      // 最後の時間より5秒以上進んでおり、かつ動画の末尾でない場合は送信予約
      seekTime = time - (time % 5)
    }
  })

  // player.on(['play'], function (e) {
  //   videoTrayOn()
  // })
  player.on(['playing'], function (e) {
    // シーク時の再生予約を実行
    // videoTrayOn()
    if (seekTime !== 0) {
      // シーク時間が0秒以外なら実行
      playTimeAPI(videoItem.dataset.token, secToTime(seekTime), 0)
      lastSendTime = seekTime
    }
    seekTime = 0

    // 定期送信処理を実行
    playDataTimer = setInterval(function () {
      const time = Math.floor(player.currentTime()) // 小数切り捨てで再生時間取得
      // console.log(time)
      if (time !== 0 && time % 5 === 0 && time !== lastSendTime) {
        // 0秒以外の5の倍数秒、かつ最後に記録した時間と異なれば送信する
        playTimeAPI(videoItem.dataset.token, secToTime(time), 0)
        lastSendTime = time
      }
    }, 500)

    // playDataTimer = setInterval(function () {
    //   if (player.isInPictureInPicture()) {
    //     // ピクチャーインピクチャーが動作していれば追従トレイから下ろす
    //     videoTrayOff()
    //   } else {
    //     videoTrayOn()
    //   }
    // }, 1000)
  })

  player.on(['pause'], function (e) {
    // 停止したら送信を止める
    clearInterval(playDataTimer)
  })
  player.on(['ended'], function (e) {
    // videoTrayOn()
    // 動画が終わったら送信する
    clearInterval(playDataTimer)
    const time = Math.floor(player.currentTime()) // 小数切り捨てで再生時間取得
    playTimeAPI(videoItem.dataset.token, secToTime(time), 1)
  })

  // 秒数skip
  player.getChild('controlBar').addChild(CreateControlBarSkipSec(), {}, 6)

  // 画質表示
  player.getChild('controlBar').addChild(quality())

  const vtt = videoItem.dataset.vtt
  if (vtt) {
    player.vttThumbnails({
      src: vtt,
    })
  }
}

//  ######  #####      ###    ##    ##
//    ##    ##  ##    ## ##    ##  ##
//    ##    #####    ##   ##    ####
//    ##    ##  ##   #######     ##
//    ##    ##   ##  ##   ##     ##

const videoField = document.getElementById('videoField') // 基本の設置位置
const videoTray = document.getElementById('videoTray') // 追従トレイ
const videoMain = document.getElementById('videoMain') // 動画本体
let isTray = false
function videoTrayOn() {
  if (isTray) {
    return
  }
  const w = player.videoWidth()
  const h = player.videoHeight()
  if (h > w) {
    // タテ動画は処理しない
    return
  }
  isTray = true

  if (player.isInPictureInPicture()) {
    // ピクチャーインピクチャーが動作していれば無効
    videoTrayOff()
    return
  }

  const videoHeight = videoMain.offsetHeight

  videoField.style.height = videoHeight + 'px'

  videoTray.appendChild(videoMain)
}

function videoTrayOff() {
  if (!isTray) {
    return
  }
  isTray = false

  videoField.style.height = 'auto'

  videoField.appendChild(videoMain)
}

/**
 * 総秒数を時:分:秒に変換
 * sec{int} 秒数
 */
function secToTime(sec) {
  // 時間を求める
  const hour = Math.floor(sec / 3600)
  sec %= 3600

  // 分を求める
  const minute = Math.floor(sec / 60)
  sec %= 60

  // 表示用にゼロパディングをかける
  const hourView = String(hour).padStart(2, '0')
  const minuteView = String(minute).padStart(2, '0')
  const secView = String(sec).padStart(2, '0')

  return hourView + ':' + minuteView + ':' + secView
}

//    ###    #####   ##            ######  ##  ###    ###  #####
//   ## ##   ##  ##  ##              ##    ##  ## #  # ##  ##
//  ##   ##  #####   ##  ########    ##    ##  ##  ##  ##  #####
//  #######  ##      ##              ##    ##  ##      ##  ##
//  ##   ##  ##      ##              ##    ##  ##      ##  #####

function playTimeAPI(token, time, finish = 0) {
  // Ajaxで再生情報を送信する

  // console.log(time)

  let ajax = new XMLHttpRequest() // Ajaxリクエスト

  ajax.open('get', playTimeApiUrl + '?token=' + token + '&time=' + time + '&finish=' + finish, true) // GET/POST, URL, 非同期処理

  ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー

  ajax.responseType = 'document' // 取得タイプ document text json
  ajax.timeout = 10000 // タイムアウト判定時間

  ajax.send() // GETリクエスト実行

  ajax.onload = function () {
    // アクセス成功
    if (ajax.status < 200 || ajax.status >= 400) {
      console.log('Error: Code ' + ajax.status) // エラー
    }
  }
  ajax.ontimeout = function (e) {
    // タイムアウト
  }
  ajax.onerror = function () {
    // Ajax処理失敗
  }
  ajax.onloadend = function () {
    // 受信成否に関わらず実行
    ajax = null
  }
}

//   ##  ##  #####  ##    ##
//   ## ##   ##      ##  ##
//   ####    #####    ####
//   ## ##   ##        ##
//   ##  ##  #####     ##

if (videoItem) {
  window.addEventListener('keydown', function (e) {
    // console.log(e.code)
    if (checkInputFocus()) {
      // テキスト入力中は無効
      return
    }
    // console.log(e.code)

    if (e.code === 'Space' || e.code === 'KeyK') {
      e.preventDefault() // デフォルトのイベントを除去
      // プレイヤーの再生切り替え
      if (player.paused()) {
        player.play()
      } else {
        player.pause()
      }
    } else if (e.code === 'KeyL') {
      e.preventDefault() // デフォルトのイベントを除去
      // 10秒進む
      skip(10, false)
    } else if (e.code === 'KeyJ') {
      e.preventDefault() // デフォルトのイベントを除去
      // 10秒戻る
      skip(-10, false)
    } else if (e.code === 'KeyF') {
      e.preventDefault() // デフォルトのイベントを除去
      // フルスクリーン
      videoItem.querySelector('.vjs-fullscreen-control').click()
    } else if (e.code === 'KeyM') {
      e.preventDefault() // デフォルトのイベントを除去
      // ミュート
      videoItem.querySelector('.vjs-mute-control').click()
    } else if (e.code === 'KeyI') {
      e.preventDefault() // デフォルトのイベントを除去
      // ピクチャーインピクチャー
      videoItem.querySelector('.vjs-picture-in-picture-control').click()
    } else if (e.code === 'KeyP') {
      e.preventDefault() // デフォルトのイベントを除去
      // 前の動画
      videoShift('prev', true)
    } else if (e.code === 'KeyN') {
      e.preventDefault() // デフォルトのイベントを除去
      // 次の動画
      videoShift('next', true)
    } else if (e.code === 'Escape') {
      e.preventDefault() // デフォルトのイベントを除去
      // ピクチャーインピクチャーを閉じる
      if (player.isInPictureInPicture()) {
        // ピクチャーインピクチャーが動作していれば切り替えボタンをクリック
        videoItem.querySelector('.vjs-picture-in-picture-control').click()
      }
      // } else if (e.code === 'ArrowRight') {
    } else if (e.code === 'Period') {
      // 加速
      e.preventDefault() // デフォルトのイベントを除去
      let speed = player.playbackRate() + 0.25
      speed = speed >= 2 ? 2 : speed // 2倍速でキャップする

      // UIで選べない刻みを飛ばす
      speed = speed === 0.75 ? 1 : speed
      speed = speed === 1.75 ? 2 : speed

      player.playbackRate(speed) // 速度変更

      speed = speed.toFixed(2) // 小数2桁にする

      // セレクトボックスを変える
      const optionList = videoItem.querySelectorAll('.rateBox option[value="' + speed + '"]')
      for (const option of optionList) {
        option.selected = true
      }
      // } else if (e.code === 'ArrowLeft') {
    } else if (e.code === 'Comma') {
      // 減速
      e.preventDefault() // デフォルトのイベントを除去
      let speed = player.playbackRate() - 0.25

      speed = speed <= 0.25 ? 0.25 : speed // 0.25倍速でキャップする
      // UIで選べない刻みを飛ばす
      speed = speed === 0.75 ? 0.5 : speed
      speed = speed === 1.75 ? 1.5 : speed

      player.playbackRate(speed) // 速度変更

      speed = speed.toFixed(2) // 小数2桁にする

      // セレクトボックスを変える
      const optionList = videoItem.querySelectorAll('.rateBox option[value="' + speed + '"]')

      for (const option of optionList) {
        option.selected = true
      }
    } else if (~e.code.indexOf('Numpad')) {
      // 指定番号*10%の位置にシーク
      e.preventDefault() // デフォルトのイベントを除去

      const step = parseInt(e.code.replace('Numpad', ''), 10) * 10

      if (step === 0) {
        player.currentTime(0)
      } else {
        const totalTime = player.duration() // 全体の再生時間

        player.currentTime((totalTime * step) / 100)
      }
    } else if (~e.code.indexOf('Digit')) {
      // 指定番号*10%の位置にシーク
      e.preventDefault() // デフォルトのイベントを除去

      const step = parseInt(e.code.replace('Digit', ''), 10) * 10

      if (step === 0) {
        player.currentTime(0)
      } else {
        const totalTime = player.duration() // 全体の再生時間

        player.currentTime((totalTime * step) / 100)
      }
    }
  })
}

// テキスト入力欄にフォーカスしているか確認する
function checkInputFocus() {
  // console.log(document.activeElement.tagName)
  return document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA'
}

//   #####     ###    ##   ##   ####  #####
//   ##  ##   ## ##   ##   ##  ##     ##
//   #####   ##   ##  ##   ##   ###   #####
//   ##      #######  ##   ##     ##  ##
//   ##      ##   ##   #####   ####   #####

const onPause = function (e) {
  if (e.target.tagName.toLowerCase() !== 'div') {
    return
  }
  if (player.paused()) {
    player.play()
  } else {
    player.pause()
  }
}
window.onPause = onPause

//    ####  #####   #####  #####  ####
//   ##     ##  ##  ##     ##     ##  ##
//    ###   #####   #####  #####  ##  ##
//      ##  ##      ##     ##     ##  ##
//   ####   ##      #####  #####  ####

const changeRate = function (rate) {
  player.playbackRate(rate)
}
window.changeRate = changeRate

//    ####  ##  ##  ##  #####
//   ##     ## ##   ##  ##  ##
//    ###   ####    ##  #####
//      ##  ## ##   ##  ##
//   ####   ##  ##  ##  ##

const skip = function skip(sec, pause = false) {
  if (pause) {
    // ポーズを伴う
    player.pause()
  }
  let newTime = player.currentTime() + sec
  player.currentTime(newTime)
  if (sec >= 1) {
    videoInfoPop(sec + '秒先へ')
  } else if (sec <= -1) {
    videoInfoPop(sec * -1 + '秒前へ')
  }
}
window.skip = skip

//   ####  ##   ##  ##  #####  ######
//  ##     ##   ##  ##  ##       ##
//   ###   #######  ##  #####    ##
//     ##  ##   ##  ##  ##       ##
//  ####   ##   ##  ##  ##       ##
// 前/次の動画へ
const videoShift = function videoShift(move, absolute = false) {
  if (move === 'prev') {
    if (!videoItem.dataset.prev) {
      console.log('no prev')
      return
    }

    const time = Math.floor(player.currentTime()) // 小数切り捨てで再生時間取得
    if (absolute) {
      // 強制的に前の動画へ
      location.href = videoItem.dataset.prev
    } else if (!getPrevVideo() || time >= 1) {
      // 再生時間が1秒を越えているか、前の動画がなければ今の動画の先頭へ
      player.currentTime(0)
      player.play()
    } else {
      // 始まったばかりなら前の動画へ
      location.href = videoItem.dataset.prev
    }
  } else if (move === 'next') {
    if (!videoItem.dataset.next) {
      console.log('no next')
      return
    }
    location.href = videoItem.dataset.next
  }
}
window.videoShift = videoShift

function getPrevVideo() {
  return videoItem.dataset.prev
}
function getNextVideo() {
  return videoItem.dataset.next
}

//  ##  ##     ##  #####   #####
//  ##  ####   ##  ##     ##   ##
//  ##  ##  ## ##  #####  ##   ##
//  ##  ##    ###  ##     ##   ##
//  ##  ##     ##  ##      #####
const videoInfo = document.getElementById('videoInfo')
let isVideoInfo = false // トーストの出現フラグ
function videoInfoPop(text) {
  if (!videoInfo) {
    // トースト要素の存在確認
    return
  }
  videoInfo.innerText = text // テキストをセット
  videoInfo.classList.add('active')
  if (!isVideoInfo) {
    isVideoInfo = true
    setTimeout(() => {
      videoInfo.classList.remove('active')
      isVideoInfo = false
    }, 1000)
  }
}

// コントロールバーに画質表示
function quality() {
  /*html*/
  let newElement = `
<div class="videoSpRight flex vcenter">
  <button id="videoMenuOpen" type="button" title="追加メニュー" class="sp-item videoMenu flex vcenter hcenter">
    <i class="is-false videoMenu__icon icon-movie-menu"></i>
  </button>
</div>
`
  const Component = videojs.getComponent('Component')
  const result = new Component(player)
  result.el().innerHTML = newElement
  return result
}

//  ###    ###  #####  ##     ##  ##   ##
//  ## #  # ##  ##     ####   ##  ##   ##
//  ##  ##  ##  #####  ##  ## ##  ##   ##
//  ##      ##  ##     ##    ###  ##   ##
//  ##      ##  #####  ##     ##   #####

window.addEventListener('click', function (e) {
  if (e.target.id !== 'videoMenuOpen') {
    return
  }
  const toggleItem = document.getElementsByClassName('js-videoSpToggle')
  itemsClass(toggleItem, 'active', 2)
})

//  #####   ######  ##     ##
//  ##  ##    ##    ####   ##
//  #####     ##    ##  ## ##
//  ##  ##    ##    ##    ###
//  #####     ##    ##     ##
//            #####  #####     #####   ##     ##  ######
//            ##     ##  ##   ##   ##  ####   ##    ##
//  ########  #####  #####    ##   ##  ##  ## ##    ##
//            ##     ##  ##   ##   ##  ##    ###    ##
//            ##     ##   ##   #####   ##     ##    ##

// skipボタンコンポーネントの作成
function CreateSkip() {
  let nextVideo = ''
  if (getNextVideo()) {
    // 次の動画があれば設定する
    const nextTitle = videoItem.dataset.nextTitle ? videoItem.dataset.nextTitle : ''
    const nextImg = videoItem.dataset.nextImg ? videoItem.dataset.nextImg : ''
    nextVideo = `<div id="nextVideo" class="nextVideo">
  <div class="nextVideo__frame">
    <button type="button" class="js-nextVideo-cancel nextVideo__close flex vcenter hcenter">
      <i class="nextVideo__closeIcon icon-close is-false"></i>
    </button>
    <div class="nextVideo__list flex bet">
      <div id="nextVideoImg" class="nextVideo__img">
        <img src="${nextImg}" alt="">
      </div>
      <div class="nextVideo__data flex vert bet">
        <div id="nextVideoTitle" class="nextVideo__title">${nextTitle}</div>
        <div class="nextVideo__count flex hend">
          <div class="nextVideo__countIn">
            <span id="nextVideoCount"></span>秒後に自動再生
          </div>
        </div>
      </div>
    </div>
    <div class="nextVideo__select flex bet">
      <button type="button" class="js-nextVideo-cancel nextVideo__btn nextVideo__btn--cancel flex vcenter hcenter">
        <span class="is-false nextVideo__btnText">キャンセル</span>
      </button>
      <button type="button" class="js-nextVideo-done nextVideo__btn nextVideo__btn--ok flex vcenter hcenter">
        <span class="is-false nextVideo__btnText">連続再生をオン</span>
      </button>
    </div>
  </div>
</div>`
  }

  let newElement = `

<div id="videoInfo" class="videoInfo"></div>
<button type="button" id="backPanel" class="backPanel"></button>
<div class="skip" id="skip">
  <div id="full-screen" class="pc-item"></div>
  <div class="movieSkip movieSkip--front-sp flex vcenter bet">
    <button type="button" id="sp-skip-b" title="前へ" class="movieSkip__item--sp">
    </button>
    <button type="button" id="sp-skip-f" title="先へ" class="movieSkip__item--sp">
    </button>
  </div>
  <div id="cover-btn"class="js-coverBtn movieSkip movieSkip--front flex vcenter bet">
    <button id="hovermenu-top"  onclick="videoShift('prev')" type="button" title="最初に戻る" class="js-coverBtn movieSkip__item movieSkip__item--sec flex vcenter hcenter">
      <i class="movieSkip__icon icon-back"></i>
    </button>
    <button id="hovermenu-play" type="button" title="再生" class="js-coverBtn movieSkip__item movieSkip__item--play flex vcenter hcenter hovermenu-play">
      <i class="movieSkip__icon play-icon icon-tri-right"></i>
    </button>
    <button id="hovermenu-next" onclick="videoShift('next')" type="button" title="次の動画へ" class="js-coverBtn movieSkip__item movieSkip__item--sec flex vcenter hcenter">
      <i class="movieSkip__icon icon-next"></i>
    </button>
  </div>
  <div class="hovermenu-quality js-quality pc-item notranslate" id="hovermenu-quality">　</div>
  <div id="autoMoveFrame" class="autoMove">
    <input class="autoMove__check" type="checkbox" id="autoMove">
    <label for="autoMove" class="autoMove__frame">
      <div class="autoMove__btn flex vcenter hcenter">
        <i class="autoMove__icon autoMove__icon--on icon-tri-right"></i>
        <i class="autoMove__icon autoMove__icon--off icon-pause"></i>
      </div>
    </label>
  </div>
</div>
${nextVideo}
`
  for (let i = 0; i < 4; i++) {
    newElement = newElement.replace('{???' + i + '}', skipTimes[i])
    newElement = newElement.replace('{???' + i + '}', Math.abs(skipTimes[i]))
  }
  const Component = videojs.getComponent('Component')
  const result = new Component(player)
  result.el().innerHTML = newElement
  return result
}
//            #####     ###    #####
//            ##  ##   ## ##   ##  ##
//  ########  #####   ##   ##  #####
//            ##  ##  #######  ##  ##
//            #####   ##   ##  ##   ##

// controlbar内のskipボタンコンポーネントの作成
function CreateControlBarSkipSec() {
  /*html*/
  let newElement = `

<div id="videoSubMenu" class="js-videoSpToggle movieSkip movieSkip--bar flex vcenter hcenter notranslate">
  <button type="button" title="前へ" onclick="skip({???0})" class="movieSkip__item movieSkip__item--sec flex vcenter hcenter pc-item">
    <i class="movieSkip__icon movieSkip__icon--sec icon-count-back"></i>
    <span class="movieSkip__num">
      {???0}
    </span>
  </button>
  <button type="button" title="前へ" onclick="skip({???1})" class="movieSkip__item movieSkip__item--sec flex vcenter hcenter">
    <i class="movieSkip__icon movieSkip__icon--sec icon-count-back"></i>
    <span class="movieSkip__num">
      {???1}
    </span>
  </button>
  <button type="button" title="先へ" onclick="skip({???2})" class="movieSkip__item movieSkip__item--sec flex vcenter hcenter pc-item">
    <i class="movieSkip__icon movieSkip__icon--sec icon-count-next"></i>
    <span class="movieSkip__num">
      {???2}
    </span>
  </button>
  <button type="button" title="先へ" onclick="skip({???3})" class="movieSkip__item movieSkip__item--sec flex vcenter hcenter">
    <i class="movieSkip__icon movieSkip__icon--sec icon-count-next"></i>
    <span class="movieSkip__num">
      {???3}
    </span>
  </button>

  <div class="sp-item fullscreen-hide">
    ${speedUi}
  </div>

  <div class="movieSkip__short flex vcenter">
  <button type="button" title="コマ戻し" onclick="skip(-0.01,true)" class="movieSkip__item movieSkip__item--step flex vcenter hcenter">
    <i class="movieSkip__icon movieSkip__icon--step icon-step-back"></i>
  </button>
  <button type="button" title="コマ送り" onclick="skip(0.01,true)" class="movieSkip__item movieSkip__item--step flex vcenter hcenter">
    <i class="movieSkip__icon movieSkip__icon--step icon-step-next"></i>
  </button>
 </div>
</div>
  `
  for (let i = 0; i < 4; i++) {
    newElement = newElement.replace('{???' + i + '}', skipTimes[i])
    newElement = newElement.replace('{???' + i + '}', Math.abs(skipTimes[i]))
  }
  const Component = videojs.getComponent('Component')
  const result = new Component(player)
  result.el().innerHTML = newElement

  return result
}

//             ####  #####   #####  #####  ####
//            ##     ##  ##  ##     ##     ##  ##
//  ########   ###   #####   #####  #####  ##  ##
//               ##  ##      ##     ##     ##  ##
//            ####   ##      #####  #####  ####

// 再生速度変更ボタンコンポーネントの作成
function CreateRateChange() {
  const Component = videojs.getComponent('Component')
  const result = new Component(player)
  result.el().innerHTML = '<div class="pc-item">' + speedUi + '</div>'

  // 折り返し処理用のDOMを設置
  const separateItem = document.createElement('div')
  separateItem.setAttribute('class', 'movieSkipFrame')
  // console.log(document.querySelector('.vjs-volume-panel').parentNode)
  document
    .querySelector('.vjs-volume-panel')
    .parentNode.insertBefore(separateItem, document.querySelector('.vjs-volume-panel').nextSibling)

  return result
}

//    ###    ##   ##  ######   #####
//   ## ##   ##   ##    ##    ##   ##
//  ##   ##  ##   ##    ##    ##   ##
//  #######  ##   ##    ##    ##   ##
//  ##   ##   #####     ##     #####
// 自動再生機能

// 設定を保存
function autoMoveSave(toggle = 1, message = 1) {
  if (message === 1) {
    if (toggle === 1) {
      videoInfoPop('自動再生オン')
    } else {
      videoInfoPop('自動再生オフ')
    }
  }
  setCookie('autoMove', toggle, 60 * 60 * 365, false) // ミュート状態をCookieに格納
}

window.addEventListener('change', function (e) {
  // 指定のIDを持つ
  if (e.target.id !== 'autoMove') {
    return
  }
  if (e.target.checked) {
    autoMoveSave(1, 1)
  } else {
    autoMoveSave(0, 1)
  }
})

// 設定をボタンに反映
function autoMoveBtnToggle() {
  const btn = document.getElementById('autoMove')
  if (!getNextVideo()) {
    // 次の動画がなければボタンを消して終了
    const frame = document.getElementById('autoMoveFrame')
    frame.classList.add('hide')
    return
  }
  const toggle = getCookie('autoMove')
  if (toggle === '1') {
    btn.checked = 1
  }
}
// 自動再生の有効無効を確認
function isAutoMove() {
  const toggle = getCookie('autoMove')
  if (toggle === '1') {
    return true
  }
  return false
}

//  ##     ##  #####  ##    ##  ######
//  ####   ##  ##      ##  ##     ##
//  ##  ## ##  #####    ####      ##
//  ##    ###  ##      ##  ##     ##
//  ##     ##  #####  ##    ##    ##
let nextTimer // 自動移動のカウントダウン
let showNextWindow = false // 自動移動画面を開いたフラグ
window.addEventListener('click', function (e) {
  if (e.target.classList.contains('js-nextVideo-done')) {
    // 自動再生をONにして次の動画へ
    clearInterval(nextTimer)
    autoMoveSave(1, 0)
    location.href = getNextVideo()
    return
  }
  if (e.target.classList.contains('js-nextVideo-cancel')) {
    // 自動再生画面を消す
    clearInterval(nextTimer)
    const nextVideo = document.getElementById('nextVideo')
    nextVideo.classList.remove('active')
    // 操作バーの入力を有効化する
    const ui = document.querySelectorAll('.vjs-control-bar,.movieSkip')
    itemsClass(ui, 'disable', 0)
  }
})

function openNextWindow() {
  if (showNextWindow) {
    // 既に開いていたら開かない
    return
  }
  // 操作バーの入力を無効化する
  const ui = document.querySelectorAll('.vjs-control-bar,.movieSkip')
  itemsClass(ui, 'disable', 1)
  // 次の動画情報を出す
  const nextVideo = document.getElementById('nextVideo')
  nextVideo.classList.add('active')
  nextCountDown() // カウントダウンを始める
  showNextWindow = true
}

function nextCountDown() {
  const countTarget = document.getElementById('nextVideoCount')
  let countDown = 8
  countTarget.innerText = countDown
  nextTimer = setInterval(function () {
    --countDown
    if (countDown <= 0) {
      // カウントダウン終了で強制移動
      clearInterval(nextTimer)
      location.href = getNextVideo()
      return
    }
    countTarget.innerText = countDown
  }, 1000)
}

//  #####  ##   ##  ##      ##
//  ##     ##   ##  ##      ##
//  #####  ##   ##  ##      ##
//  ##     ##   ##  ##      ##
//  ##      #####   ######  ######

// フルスクリーン処理
function isFullScreen() {
  if (
    (document.fullscreenElement !== undefined && document.fullscreenElement !== null) || // HTML5 標準
    (document.mozFullScreenElement !== undefined && document.mozFullScreenElement !== null) || // Firefox
    (document.webkitFullscreenElement !== undefined && document.webkitFullscreenElement !== null) || // Chrome・Safari
    (document.webkitCurrentFullScreenElement !== undefined && document.webkitCurrentFullScreenElement !== null) || // Chrome・Safari (old)
    (document.msFullscreenElement !== undefined && document.msFullscreenElement !== null)
  ) {
    // IE・Edge Legacy
    return true // fullscreenElement に何か入ってる = フルスクリーン中
  }

  return false // フルスクリーンではない or フルスクリーン非対応の環境（iOS Safari など）
}

const hovermenu = document.getElementById('skip')
const fullScreen = document.getElementById('full-screen')
if (fullScreen) {
  if (deviceOS === 'pc') {
    //PC
    // シングルクリック時はUI消去
    hovermenu.addEventListener('click', function () {
      // if (player.paused()) {
      //   player.play()
      // } else {
      //   player.pause()
      // }
      hovermenu.classList.add('abs-hide')
      setTimeout(() => {
        hovermenu.classList.remove('abs-hide')
      }, 3000)
    })
    // ダブルクリック時のフルスクリーン処理
    hovermenu.addEventListener('dblclick', function () {
      if (isFullScreen()) {
        player.exitFullscreen()
      } else {
        player.requestFullscreen()
      }
    })
  }
}

//  ##   ##   #####   ##   ##  #####  #####
//  ##   ##  ##   ##  ##   ##  ##     ##  ##
//  #######  ##   ##  ##   ##  #####  #####
//  ##   ##  ##   ##   ## ##   ##     ##  ##
//  ##   ##   #####     ###    #####  ##   ##

const controlBar = document.querySelector('.vjs-control-bar') // 操作バー　フルスクリーン時に消す

// 秒数とpicture_in_pictureボタンをhovermenuに表示
const timeControl = document.getElementsByClassName('vjs-time-control')
itemsClass(timeControl, 'notranslate', true)
const pipControl = document.getElementsByClassName('vjs-picture-in-picture-control')
if (hovermenu && timeControl && pipControl) {
  let frontTimer
  hovermenu.addEventListener('mousemove', function () {
    itemsClass(timeControl, 'show', 1)
    itemsClass(pipControl, 'show', 1)
    clearTimeout(frontTimer)
    frontTimer = setTimeout(function () {
      itemsClass(timeControl, 'show', 0)
      itemsClass(pipControl, 'show', 0)
    }, 3000)
  })
}

// hovermenu再生ボタン
let playButton = document.getElementById('hovermenu-play')
if (playButton) {
  playButton.addEventListener('click', (event) => {
    if (player.paused()) {
      player.play()
    } else {
      player.pause()
    }
  })
}

// 自作hovermenu画質
// let quality = document.getElementById('hovermenu-quality')
// quality.innerHTML = ''

// ここからSP要素処理
// ダブルクリック時拡大しない
document.addEventListener(
  'dblclick',
  function (e) {
    e.preventDefault()
  },
  { passive: false }
)

const doubleTapTime = 350 // ダブルタップの受付時間

//  ######    ###    #####             ##
//    ##     ## ##   ##  ##            ##
//    ##    ##   ##  #####   ########  ##
//    ##    #######  ##                ##
//    ##    ##   ##  ##                ######

// タップ時のスキップ処理
let tapLeftCount = 0
// 要素を取得
const spSkip_b = document.getElementById('sp-skip-b')

// イベントを登録
if (deviceOS !== 'pc' && spSkip_b) {
  spSkip_b.addEventListener('touchstart', function (e) {
    if (!tapLeftCount) {
      ++tapLeftCount
      firstTapAct()
      setTimeout(function () {
        if (tapLeftCount === 1) {
          // 指定ミリ秒以内に2回目のタップがなければシングルタップと判定
          tapLeftCount = 0
          singleTapAct()
        }
      }, doubleTapTime)
    } else {
      tapLeftCount = 0
      skip(skipTimes[0])
      doubleTapAct()
    }
  })
}

//  ######    ###    #####             #####
//    ##     ## ##   ##  ##            ##  ##
//    ##    ##   ##  #####   ########  #####
//    ##    #######  ##                ##  ##
//    ##    ##   ##  ##                ##   ##

let tapRightCount = 0
// 要素を取得
const spSkip_f = document.getElementById('sp-skip-f')
// イベントを登録
if (deviceOS !== 'pc' && spSkip_f) {
  spSkip_f.addEventListener('touchstart', function (e) {
    if (!tapRightCount) {
      // タップの回数を+1
      ++tapRightCount
      firstTapAct()
      setTimeout(function () {
        if (tapRightCount === 1) {
          // 指定ミリ秒以内に2回目のタップがなければシングルタップと判定
          tapRightCount = 0
          singleTapAct()
        }
      }, doubleTapTime)
    } else {
      tapRightCount = 0
      skip(skipTimes[2])
      doubleTapAct()
    }
  })
}

const progressBar = document.querySelector('.vjs-progress-control')

if (videoItem && deviceOS === 'pc') {
  videoItem.addEventListener('mousemove', function (e) {
    firstTapAct()
  })
}

function firstTapAct() {
  // hovermenuなど表示
  progressBar.classList.add('show')
  hovermenu.classList.add('show')
  itemsClass(timeControl, 'show', 1)
  itemsClass(pipControl, 'show', 1)
  setTimeout(function () {
    controlBar.classList.add('show')
  }, 500)
  setTimeout(function () {
    progressBar.classList.remove('show')
    hovermenu.classList.remove('show')
    itemsClass(pipControl, 'show', 0)
    if (deviceOS !== 'pc') {
      itemsClass(timeControl, 'show', 0)
    }
  }, 2000)
  let ctrlTimer = setTimeout(function () {
    controlBar.classList.remove('show')
  }, 3000)
  controlBar.addEventListener('mousemove', function (e) {
    clearTimeout(ctrlTimer)
    ctrlTimer = setTimeout(function () {
      controlBar.classList.remove('show')
    }, 3000)
  })
  controlBar.addEventListener('touchstart', function (e) {
    clearTimeout(ctrlTimer)
    ctrlTimer = setTimeout(function () {
      controlBar.classList.remove('show')
    }, 3000)
  })
}

const coverBtn = document.getElementsByClassName('js-coverBtn') // 画面前面のボタン
function singleTapAct() {
  // 再生切り替え
  if (player.paused()) {
    player.play()
  } else {
    player.pause()
  }
  setTimeout(function () {
    itemsClass(coverBtn, 'active', 1) // 画面内ボタンの操作を受け付ける
  }, 100)
  setTimeout(function () {
    itemsClass(coverBtn, 'active', 0)
  }, 1000)
}
function doubleTapAct() {
  hovermenu.classList.remove('show')
  itemsClass(timeControl, 'show', 0)
  itemsClass(pipControl, 'show', 0)
}

if (videoItem) {
  // 画面向き判定
  if (deviceOS === 'ios') {
    window.onorientationchange = directionCheck
  }
  if (deviceOS === 'android') {
    window.onresize = directionCheck
  }
  directionCheck()
}
function directionCheck() {
  const direction = Math.abs(window.orientation)
  if (isFullScreen()) {
    if (direction !== 90) {
      screen.orientation.lock('landscape')
    }
  } else {
    // player.exitFullscreen()
  }
}
function isDeviceOS() {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('iphone') > -1) {
    // iPhone
    return 'ios'
  }
  if (ua.indexOf('ipad') > -1) {
    // iPad
    return 'ios'
  }
  if (ua.indexOf('android') > -1 && ua.indexOf('mobile') > -1) {
    // Android
    return 'android'
  }
  if (ua.indexOf('android') > -1 && ua.indexOf('mobile') === -1) {
    // Android Tablet
    return 'android'
  }
  return 'pc'
}

// DOM配列のクラス制御
function itemsClass(itemList, className, toggle = 1) {
  if (toggle === 1) {
    for (const item of itemList) {
      item.classList.add(className)
    }
  } else if (toggle === 0) {
    for (const item of itemList) {
      item.classList.remove(className)
    }
  } else if (toggle === 2) {
    for (const item of itemList) {
      item.classList.toggle(className)
    }
  }
}

//   #####   ##   ##    ###
//  ##   ##  ##   ##   ## ##
//  ##   ##  ##   ##  ##   ##
//   #####   ##   ##  #######
//  ##        #####   ##   ##
// 動画サイズから画質を求める
function setQuality(item) {
  const text = item.innerText
  const qualityView = document.getElementById('hovermenu-quality')

  if (text === 'auto' || ~text.indexOf('Auto')) {
    item.innerText = '自動'
    qualityView.innerText = '自動'
    item.dataset.quality = 'auto'
    return
  }
  if (text === '4K') {
    return
  }
  const size = parseInt(text, 10)
  if (size >= 2160) {
    item.innerText = '4K'
    qualityView.innerText = '4K'
    item.dataset.quality = '4k'
  } else if (size >= 1080) {
    item.innerText = 'FHD'
    qualityView.innerText = 'FHD'
    item.dataset.quality = 'fhd'
  } else if (size >= 720) {
    item.innerText = 'HD'
    qualityView.innerText = 'HD'
    item.dataset.quality = 'hd'
  } else if (size <= 719) {
    item.innerText = 'SD'
    qualityView.innerText = 'SD'
    item.dataset.quality = 'sd'
  }
}

function videoQualityButtonFix() {
  const quaLabel = document.querySelectorAll('.vjs-quality-selector .vjs-icon-placeholder,.vjs-menu-item')

  for (const iterator of quaLabel) {
    setQuality(iterator)
  }

  const observeItem = document.querySelector('.vjs-quality-selector button')
  if (observeItem) {
    const observer = new MutationObserver((records) => {
      if (records[0].target.tagName !== 'SPAN') {
        return
      }
      setQuality(records[0].target)
    })
    observer.observe(observeItem, {
      // 指定要素の変化を監視
      childList: true, // 子要素の監視
      subtree: true, // 子孫要素の監視
      // attributes: true, // 属性の変化を監視
      // attributeFilter: ['style'], // 監視する属性を限定する場合は指定
      characterData: true, // 文字の監視
    })
  }
}

//   ####    #####  ######
//  ##       ##       ##
//  ##  ###  #####    ##
//  ##   ##  ##       ##
//   ####    #####    ##
function _get(name = '') {
  if (name === '' || window.location.search.length <= 1) {
    return false
  }
  // 最初の1文字 (?記号) を除いてデコードした文字列を取得する
  const query = decodeURIComponent(window.location.search.substring(1))

  if (!~query.indexOf(name)) {
    // 目的の名前がパラメータになければ終了
    return false
  }

  // クエリの区切り記号(&)で文字列を配列に分割する
  const parameters = query.split('&')
  for (const item of parameters) {
    // パラメータ名とパラメータ値に分割する
    const element = item.split('=')
    const paramName = element[0]
    const paramValue = element[1]
    if (paramName === name) {
      return paramValue
    }
  }
  return false
}

//                      ####    #####  #####   ##   ##   ####
//                      ##  ##  ##     ##  ##  ##   ##  ##
//  ########  ########  ##  ##  #####  #####   ##   ##  ##  ###  ########  ########
//                      ##  ##  ##     ##  ##  ##   ##  ##   ##
//                      ####    #####  #####    #####    ####
function videoDebug(e) {
  const debug = document.getElementById('videoDebug')
  if (!debug) {
    return
  }
  let text = ''

  text += `<b>動画情報</b>`
  text += `<table>`

  text += `<tr><th>ソース</th><td><a href="${player.src()}" target="_blank">${player.src()}</a></td></tr>`
  text += `<tr><th>解像度</th><td>${player.videoWidth()} x ${player.videoHeight()}</td></tr>`
  text += `<tr><th>再生秒数</th><td>${player.duration()}sec</td></tr>`
  text += `<tr><th>サムネイル</th><td><a href="${player.poster()}" target="_blank">${player.poster()}</a></td></tr>`
  const vtt = videoItem.dataset.vtt
  text += `<tr><th>VTT</th><td><a href="${vtt}" target="_blank">${vtt}</a></td></tr>`
  text += `<tr><th>UA</th><td>${window.navigator.userAgent}</tr>`

  text += `</table>`

  debug.innerHTML = debug.innerHTML + text
  debug.classList.add('active')
  window.popToast('<a href="#videoDebug" >デバッグ情報を出力しました</a>')
}

window.onerror = (message, file, lineNo, colNo, error) => {
  const debug = document.getElementById('videoDebug')
  if (!debug) {
    return
  }
  let text = ''

  text += `<b>エラー情報</b>`
  text += `<table>`
  text += `<tr><th>メッセージ</th><td>${message}</td></tr>`
  text += `<tr><th>ファイル</th><td>${file}</td></tr>`
  text += `<tr><th>行</th><td>${lineNo}</td></tr>`
  text += `<tr><th>列</th><td>${colNo}</td></tr>`
  text += `<tr><th>エラー</th><td>${error}</td></tr>`
  text += `</table>`

  debug.innerHTML = debug.innerHTML + text
  debug.classList.add('active')
  window.popToast('<a href="#videoDebug" >デバッグ情報を出力しました</a>')
}

/**
 * @function scrollValToggle
 * @description スクロール量を基準にクラスを着脱する
 * @param {String} targetSelector ターゲットとする一意なセレクタ
 * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
 * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
 * @param {String} toggleClass 切り替えるクラス名
 * @return {Void}
 */
scrollValToggle('#videoTray', 45, false, 'scroll')
function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  let isExecute = false // 実行中フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleActive = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply() // 初回起動
  function scrollValToggleApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.pageYOffset // スクロール量
      if (scrollY >= scrollValStart && !scToggleActive) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleActive = true
      } else if (scrollY < scrollValStart && scToggleActive) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleActive = false
      }
      if (scrollValEnd && scToggleActive) {
        // 終了ラインが設定されている場合は終了判定
        if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
          //スクロール終了範囲を過ぎていたらOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
      }
      isExecute = false
    })
  }
}
